import { render, staticRenderFns } from "./NoticeBar.vue?vue&type=template&id=15614b80"
import script from "./NoticeBar.vue?vue&type=script&lang=ts"
export * from "./NoticeBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports